import React from 'react';
import { GlobeIcon, PackageCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { images } from '../../data/content';
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-6 sm:pt-10" data-id="element-139" data-mp="cv33zwet0efu">
      <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-140" data-mp="huny9tj13ym8">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-141" data-mp="mu0ngkxdhhrz">
          <div className="flex items-center gap-2" data-id="element-142" data-mp="mtsciykt8mjf">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-ink" data-id="element-143" data-mp="quubrfeq8yle">
              <PackageCheckIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-144" data-mp="vlu9gmvo7koy" />
            </span>
            <span className="font-serif text-xl font-black text-ink" data-id="element-145" data-mp="10lysoknyqtiv">
              Picking Control <span className="rounded bg-gold px-1" data-id="element-146" data-mp="15ks5eavfeghz">30</span>™
            </span>
          </div>
        </div>

        <h1 className="mt-6 font-serif text-[34px] font-black leading-[1.08] text-ink sm:text-5xl md:text-6xl" data-id="element-147" data-mp="1aj3eukht6ozo">
          The 30-day system to reduce picking errors and{' '}
          <em className="bg-[linear-gradient(transparent_58%,#FFC700_58%)] px-1 italic" data-id="element-148" data-mp="4opsy808q36r">take back control</em> of your
          warehouse
        </h1>

        <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-ink/80 sm:text-xl" data-id="element-149" data-mp="3vvsmh63jwlk5">
          A step-by-step operating system to identify the root causes of picking errors, track the KPIs that matter, and
          build a repeatable improvement process in just 30 days. Includes <strong className="text-ink" data-id="element-150" data-mp="nexqmal681fk">6 premium volumes</strong>,{' '}
          <strong className="text-ink" data-id="element-151" data-mp="iohcspdfudso">5 professional toolkits</strong>, checklists, KPI frameworks, diagnostic matrices
          and a <strong className="text-ink" data-id="element-152" data-mp="enp5i1o4miz1">complete 30-day plan</strong>.
        </p>

        <img src={images.mockup} alt="Picking Control 30™ — 6 volumes, 5 bonus toolkits, dashboards and templates" className="mt-8 w-full max-w-2xl" data-id="element-153" data-mp="1b4jrd2h6yopo" />

        <div className="mt-6 w-full max-w-xl" data-id="element-154" data-mp="30lxdm9z3wawp">
          <CtaButton id="hero-cta" label="Get Picking Control 30™" data-id="element-155" data-mp="30n8gm7kq9emr" />
          <p className="mt-3 text-sm text-muted" data-id="element-156" data-mp="35ljqgib0vp4z">
            Instant access · One-time payment of <strong className="text-ink" data-id="element-157" data-mp="2qwdtz23kkd0s">$27 USD</strong> · Lifetime access · 7-day
            guarantee
          </p>
        </div>

        <div className="mt-8" data-id="element-158" data-mp="2vu5o82rosb85">
          <Countdown data-id="element-159" data-mp="2vtdyv9oon9qb" />
        </div>

        <p className="mt-5 flex items-center gap-2 text-sm font-medium text-ink/70" data-id="element-160" data-mp="2hvpf656cq8mu">
          <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-161" data-mp="2muiwy9so8lst" />
          Currency conversion is automatically handled based on your location.
        </p>
      </div>
    </header>;
}